module.exports = __webpack_public_path__ + "static/media/show_blue.e80f734b.svg";